import styled from "@emotion/styled";
import React, { ReactElement } from "react";
import { VisitInstanceDetails } from "../../messages";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import ClockInOutRanges from "../ClockInOutRanges/ClockInOutRanges";
import { AppBottomSheet } from "../Generic/AppBottomSheet";
import { AppButton } from "../Generic/AppButton";
import { AppOverlay } from "../Generic/AppOverlay";
import Flex from "../Generic/Flex";
export interface VisitReminderBottomSheetProps {
  isOpen: boolean;
  presentVisit: VisitInstanceDetails;
  onClickStartNow: (visit: VisitInstanceDetails) => void;
  onRequestClose: () => void;
}
export function VisitReminderBottomSheet(props: VisitReminderBottomSheetProps): ReactElement {
  const visitStartTime = props.presentVisit.startTimeLocal.toLocalTime();

  const visitEndTime = props.presentVisit.endTimeLocal.toLocalTime();

  const { clockOutToleranceMinutes, clockInToleranceMinutes } =
    props.presentVisit.publicVisitDetails;

  return (
    <AppOverlay>
      <VisitReminderBottomSheet.Root
        isOpen={props.isOpen}
        onRequestClose={props.onRequestClose}
        rounded={true}
      >
        <Flex>
          <VisitReminderBottomSheet.Content>
            <VisitReminderBottomSheet.Header>
              {translate(STRINGS.DONT_FORGET_TO_CLOCK_IN_OUT_AND_COMPLETE_TASKS)}
            </VisitReminderBottomSheet.Header>

            <VisitReminderBottomSheet.PatientData>
              {`${translate(STRINGS.PATIENT_NAME)}
                  :  
                  ${props.presentVisit.confidentialVisitDetails.patientName}`}
            </VisitReminderBottomSheet.PatientData>

            <VisitReminderBottomSheet.PatientData>
              {`${translate(STRINGS.ADDRESS)}
                  :  
                  ${props.presentVisit.confidentialVisitDetails.patientAddress}`}
            </VisitReminderBottomSheet.PatientData>

            <ClockInOutRanges
              visitStartTime={visitStartTime}
              visitEndTime={visitEndTime}
              clockInToleranceMinutes={clockInToleranceMinutes}
              clockOutToleranceMinutes={clockOutToleranceMinutes}
            />
          </VisitReminderBottomSheet.Content>
          <VisitReminderBottomSheet.Image />
        </Flex>
        <AppButton
          variant="filled"
          color="primary"
          onClick={() => props.onClickStartNow(props.presentVisit)}
        >
          {translate(STRINGS.START_NOW)}
        </AppButton>
        <AppButton variant="outline" color="black" onClick={props.onRequestClose}>
          {translate(STRINGS.I_WILL_DO_IT_LATER)}
        </AppButton>
      </VisitReminderBottomSheet.Root>
    </AppOverlay>
  );
}

VisitReminderBottomSheet.Root = styled(AppBottomSheet)`
  .AppBottomSheet_Container {
    border-radius: 24px 24px 0 0;
    color: #283847;
    padding: 8px;

    .clockRangesContainer {
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 12px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .clockRange {
        display: flex;
        gap: 5px;
      }
    }

    .AppButton {
      margin-top: 4px;
      width: 100%;
    }
  }
`;

VisitReminderBottomSheet.PatientData = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 15px;
  color: #53606c;
  gap: 16px;
  display: flex;
`;

VisitReminderBottomSheet.Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: calc(100% - 120px);
  margin-bottom: 20px;
`;

VisitReminderBottomSheet.Header = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
`;

VisitReminderBottomSheet.Image = styled.div`
  width: 128px;
  height: 174px;
  position: fixed;
  background: url(../assets/visit-reminder.svg);
  right: 0;
  bottom: 148px;
`;
